export default {
  currentPaletteColors: {
    height: "calc(100vh - 64px)",
    margin: "0",
    padding: "0",
  },
};
